import { SportsList } from './SportsList';

export * from './SportsList';

export default SportsList;
